import { createSelector } from 'reselect';
import { MainCurrency } from '../../config';
export const makeSelectAmount = createSelector(state => state.connectWallet, (_, coinType) => coinType, (connectWallet, coinType) => {
  switch (coinType) {
    case MainCurrency.THETAN_COIN:
      return connectWallet.thcBalance;

    case MainCurrency.THETAN_GEM:
      return connectWallet.thgBalance;

    default:
      throw new Error('Currency is not supported!');
  }
});